<template>
  <el-table
    :data="data"
    :height="height"
    border
    empty-text="Sin datos"
    :highlight-current-row="false"
    style="width: 100%"
  >
    <el-table-column
      v-for="(column, index) in props.columns"
      :key="`col${index}`"
      :prop="column.field"
      :label="column.label"
      :width="column.width === 0 ? null : column.width"
      :sortable="column.sortable"
    >
      <template #default="scope">
        {{ scope.row[column.field] }}
      </template>
    </el-table-column>
    <el-table-column
      label="Acciones"
      width="110"
      align="center"
    >
      <template #default="scope">
        <el-button
          :icon="IconEdit"
          @click.prevent="editRow(scope.row)"
        ></el-button>
        <el-button
          :icon="IconDelete"
          type="danger"
          @click.prevent="deleteRow(scope.row)"
        ></el-button>
      </template>
    </el-table-column>
    <template #append>
      <infinite-loading
        :distance="100"
        :identifier="identifier"
        :firstload="false"
        @infinite="infiniteHandler"
      >
        <template #spinner>Cargando datos...</template>
        <template #complete>No hay mas datos...</template>
        <template #error>Hubo un error...</template>
      </infinite-loading>
    </template>
  </el-table>
</template>

<script setup>
import {
  ref,
  markRaw,
} from 'vue';
import InfiniteLoading from 'v3-infinite-loading';
import { useMessageError } from '@/shared/composables/message_error.js';
import IconEdit from '~icons/mdi/edit';
import IconDelete from '~icons/mdi/delete';

const identifier = +new Date();
const isLoading = ref(false);

const props = defineProps({
  data: Array,
  columns: Array,
  requestApi: {
    type: Function,
    required: true,
  },
  requestArgs: {
    type: Object,
  },
  height: {
    type: Number,
    default: 300,
  },
});

const emit = defineEmits(['edit', 'delete']);

const deleteRow = (row) => {
  emit('delete', row);
};

const editRow = (row) => {
  emit('edit', row);
};

const infiniteHandler = async ($state) => {
  isLoading.value = true;
  try {
    const result = await props.requestApi(props.requestArgs);
    if (result === true) {
      $state && $state.loaded();
    } else {
      $state && $state.complete();
    }
  } catch (err) {
    useMessageError().open(err);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped></style>
